<div class="faspinner" *ngIf="loading">
    <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
</div>
<div *ngIf="!loading">
    <!-- <app-back-page (backAction)="backToMainPage()"></app-back-page> -->
    <div id="form-container">
        <form (submit)="onFormSubmit($event)">
            <dx-form [formData]="changeStatusForm" [showColonAfterLabel]="true" [showValidationSummary]="true"
                style="padding: 1rem 2rem;margin: 2rem 0rem;" [rtlEnabled]="currentLang=='ar'?true:false"
                validationGroup="true">
                <dxi-item itemType="group" caption="{{'addemployee.title'|translate}}">
                    <dxi-item itemType="tabbed">
                        <dxo-tab-panel-options [deferRendering]="false">
                        </dxo-tab-panel-options>

                        <!-- tab1 -->
                        <dxi-tab title="{{'addemployee.description.desc1'|translate}}" [colCount]="8">
                            <dxo-col-count-by-screen [xs]="1" [sm]="1" [md]="4" [lg]="4"></dxo-col-count-by-screen>
                            <dxi-item itemType="group" caption="{{'hr.ChangeEmployeeWorkStatus'|translate}}"
                                [colCount]="2" [colSpan]="4">

                                <!-- <dxi-item dataField="employeeId" editorType="dxLookup" [colSpan]="1" disabled="true"
                                    [editorOptions]="{dataSource: employeeMenu, displayExpr:'nameAr' ,valueExpr :'id' ,searchEnabled: true, showClearButton: true}">
                                    <dxo-label template="{{'hr.employeeId' |translate}}"></dxo-label>
                                </dxi-item> -->
                                <dxi-item dataField="employeeWorkStatus" editorType="dxLookup" [colSpan]="1"
                                    [editorOptions]="{dataSource: employeeWorkStatusMenu, displayExpr:'name' ,valueExpr :'code' ,searchEnabled: true, showClearButton: true}">
                                    <dxo-label template="{{'hr.EmployeeWorkStatus' |translate}}"></dxo-label>
                                </dxi-item>

                                <dxi-item dataField="isActive" editorType="dxCheckBox" [colSpan]="1">
                                    <dxo-label template="هل الموظف نشط"></dxo-label>
                                </dxi-item>
                                
                                <dxi-item dataField="bankCode" editorType="dxTextBox"[colSpan]="1">
                                    <dxo-label template="{{'addemployee.tab1.bankCode' |translate}}"></dxo-label>
                                </dxi-item>
            <dxi-item
    dataField="changeEmployeeStatusDate"
    editorType="dxDateBox"
    [editorOptions]="{
      displayFormat: 'yyyy-MM-dd',
      type: 'date'
    }">

    <dxo-label text="تاريخ توقف الموظف عن العمل"></dxo-label>

</dxi-item>
                            </dxi-item>
                            
                        </dxi-tab>
                        
                        <!-- tab-5 -->
                        <dxi-tab title="{{'permission.user.title'|translate}}" [colCount]="8">
                            <dxi-item itemType="group" [colSpan]="8" [colCount]="8">
                                <dxi-item dataField="createdUserName" [colSpan]="4">
                                    <dxo-label template="{{'permission.user.userName'|translate}}"></dxo-label>
                                </dxi-item>
                                <dxi-item dataField="email" [colSpan]="4">
                                    <dxo-label template="{{'permission.user.email'|translate}}"></dxo-label>
                                </dxi-item>
                                <dxi-item dataField="passwordHash" [colSpan]="4">
                                    <dxo-label template="{{'loginComponent.Password'|translate}}"></dxo-label>
                                </dxi-item>
                                <dxi-item [colSpan]="4">
                                    <!-- <app-dropdown [m]="roleDataSource" [value]="workvalue"
                                        head="{{'permission.role'|translate}}" [coulmn]="RoleColumn">
                                    </app-dropdown> -->

                                    <dx-drop-down-box
                                    [(value)]="workvalue"
                                    [inputAttr]="{ 'aria-label': 'Owner' }"
                                    valueExpr="id"
                                    displayExpr="name"
                                    placeholder="Select a value..."
                                    [showClearButton]="true"
                                    [dataSource]="roleDataSource"
                                  >
                                    <div *dxTemplate="let data of 'content'">
                                      <dx-data-grid
                                        [dataSource]="roleDataSource"
                                        keyExpr="id"
                                        [columns]="RoleColumn"
                                        [selection]="{ mode: 'multiple' }"
                                        [hoverStateEnabled]="true"
                                        [paging]="{ enabled: true, pageSize: 10 }"
                                        [filterRow]="{ visible: true }"
                                        [scrolling]="{ mode: 'virtual' }"
                                        [height]="345"
                                        [(selectedRowKeys)]="workvalue"
                                      >
                                      </dx-data-grid>
                                    </div>
                                  </dx-drop-down-box>
                                </dxi-item>
                                <dxi-item dataField="changePassword" editorType="dxCheckBox" [colSpan]="4">
                                    <dxo-label template="{{'hr.ChangePassword' |translate}}"></dxo-label>
                                </dxi-item>
                            </dxi-item>
                        </dxi-tab>
                        
                         <dxi-tab title="{{'hr.EmployeeAttachment'|translate}}" [colCount]="8">
                          <dx-data-grid
  [dataSource]="employeeAttachments"
  [showBorders]="true"
  [columnAutoWidth]="true"
  [allowColumnResizing]="true"
  height="400px">
  
  <dxi-column dataField="id" caption="ID" [width]="70"></dxi-column>
  <dxi-column dataField="notes" caption="Notes"></dxi-column>
  <dxi-column dataField="employeeId" caption="Employee ID" [visible]="false"></dxi-column>
<dxi-column
  dataField="employeeAttachmentTypeId"
  [lookup]="{
    dataSource: AttacmentMenu,
    valueExpr: 'id',
    displayExpr: currentLang === 'ar' ? 'nameAr' : 'nameEn'
  }"
  caption="{{ 'hr.EmployeeAttachmentTypes' | translate }}">
</dxi-column>
  


      <dxi-column
    dataField="fileUrl"
    [width]="100"
    [allowFiltering]="false"
    [allowSorting]="false"
    caption="{{'cdc.image'|translate}}"
    cellTemplate="cellTemplate"
  ></dxi-column>
      <div *dxTemplate="let data of 'cellTemplate'">
      <img
          [src]="data.value"
          alt="Picture of {{ data.data.FirstName }} {{ data.data.LastName }}"
          width="40" height="40" style="object-fit: cover; border-radius: 5px;"
          (click)="openImagePopup(data.value)"
      />
  </div>

</dx-data-grid>
                         </dxi-tab>


                    </dxi-item>
                    <dxi-item>
                         <dx-data-grid #grid class="dx-card wide-card" [dataSource]="[changeStatusForm]"
  [showBorders]="false"
   
    [focusedRowEnabled]="true" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
    [columnHidingEnabled]="true" [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false"
    [showBorders]="false" [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false">
    <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
    <dxo-pager [visible]="true"></dxo-pager>
    <dxo-editing mode="row" 
      [texts]="button">
      <dxo-texts [addRow]="addrowfun('addemployee.subtitle')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>
<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
      [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <!-- <dxi-column
        dataField="id" [visible]="false"
        [width]="90"
        [hidingPriority]="2">
      </dxi-column> -->
    <dxi-column dataField="id"  caption="{{'salary.employeeId'|translate}}">
    </dxi-column>
    <dxi-column dataField="nameAr"  caption="{{'tableinfo.NameAr' | translate}}" >
    </dxi-column>
    <dxi-column dataField="nameEn"  caption="{{'tableinfo.NameEn' | translate}}" >
  </dxi-column>
    <dxi-column dataField="managementName"  caption="إســم الإدارة" >
  </dxi-column>


  <dxi-column dataField="employeeWorkStatus" caption="{{'hr.EmployeeWorkStatus'|translate}}">
            <dxo-lookup [dataSource]="employeeWorkStatusMenu" valueExpr="code"
                displayExpr="name"></dxo-lookup>
        </dxi-column>
  <dxi-column dataField="workSystemId" caption="{{'tableinfo.workSystem'|translate}}" [allowEditing]="false">
    <dxo-lookup
    [dataSource]="workSystemdropdown"
    valueExpr="id"
    [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
  </dxi-column>
  <dxi-column dataField="nationalID"  caption="{{'addemployee.tab1.NationalID' | translate}}" >
  </dxi-column>
  <dxi-column dataField="createdUserId" caption="{{'cdc.UserName' | translate}}">
    <dxo-lookup
      [dataSource]="UserDropDown"
      valueExpr="id"
      displayExpr="userName">
    </dxo-lookup>
    <dxo-label template="{{'cdc.userName' | translate}}"></dxo-label>
  </dxi-column>
    <dxi-column dataField="branchId" caption="{{'basic-info.branch.branchName'|translate}}"[allowEditing]="false">
      <dxo-lookup
      [dataSource]="branchesdropdown"
      valueExpr="id"
      [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column>
    <!-- <dxi-column dataField="accountId" caption="{{'basic-info.accountId'|translate}}"[allowEditing]="false">
      <dxo-lookup
      [dataSource]="branchesdropdown"
      valueExpr="id"
      [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column> -->
    <dxi-column dataField="jobTitleId" caption="{{'salary.jobTitleId'|translate}}" [allowEditing]="false">
      <dxo-lookup
      [dataSource]="jobTitleDropDown"
      valueExpr="id"
      [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="departmentId" caption="{{'salary.department'|translate}}" [allowEditing]="false">
      <dxo-lookup
      [dataSource]="departmentDropDown"
      valueExpr="id"
      [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column>
   
    <dxi-column dataField="bankCode" caption="{{'addemployee.tab1.bankCode'|translate}}" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="phoneNumber" caption="{{'basic-info.branch.phoneNumber'|translate}}" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="mobileNumber" caption="{{'basic-info.branch.mobile'|translate}}" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="email" caption="{{'tableinfo.email'|translate}}" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="dateOfHiring" caption="{{'addemployee.tab1.DateOfHiring'|translate}}" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="workPeriod" caption="{{'addemployee.tab1.workperiod'|translate}}" [allowEditing]="false">
    </dxi-column>
    
    
    <dxi-column dataField="fingerPrintNumber"  caption="{{'addemployee.tab1.FingerPrintNumber'|translate}}" [allowEditing]="false"></dxi-column>
    <!-- <dxi-column dataField="managementId" caption="{{'salary.management'|translate}}" [allowEditing]="false">
      <dxo-lookup
      [dataSource]="managementDropDown"
      valueExpr="id"
      [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column> -->    
    <dxi-column dataField="isActive" caption="{{'tableinfo.isActive'|translate}}">
    </dxi-column>
    <dxi-column dataField="isInsurance" caption="{{'addemployee.tab1.isinsurance' | translate}}"></dxi-column>
  </dx-data-grid>

                    </dxi-item>

                    <dxi-item itemType="button" [buttonOptions]="buttonOptions">
                    </dxi-item>

                    <dxi-item itemType="button" [buttonOptions]="sendoptions">
                    </dxi-item>

                    <dxi-item itemType="button" [buttonOptions]="contractoptions">
                    </dxi-item>

                </dxi-item>
            </dx-form>
        </form>
    </div>
</div>